import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { services } from '../data/siteData';
import { useReveal } from '../hooks/useReveal';
import './Inner.css';

function R({ children, className }) {
  const ref = useReveal();
  return <div ref={ref} className={`reveal ${className || ''}`}>{children}</div>;
}

export function Services() {
  return (
    <div>
      <section className="page-hero">
        <div className="ph-orb ph-orb-1" />
        <div className="ph-orb ph-orb-2" />
        <div className="container page-hero-inner">
          <div className="badge"><div className="badge-dot">✦</div>What We Do</div>
          <h1 className="ph-title">
            End-to-end <span className="grad-text">digital services</span>
          </h1>
          <p className="ph-sub">
            One team across every layer of your stack — from first pixel to AI-powered scale.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="services-page-grid">
            {services.map(s => (
              <R key={s.id}>
                <Link to={`/services/${s.id}`} className="svc-card">
                  <div className="svc-card-top" style={{ background: s.color }}>
                    <span className="svc-card-emoji">{s.icon}</span>
                  </div>
                  <div className="svc-card-body">
                    <div className="svc-tag">{s.tagline}</div>
                    <h2>{s.title}</h2>
                    <p>{s.shortDesc}</p>
                    <div className="svc-meta">
                      <span>⏱ {s.timeline}</span>
                      <span>💰 From {s.startingAt}</span>
                    </div>
                    <div className="svc-cta">Learn more →</div>
                  </div>
                </Link>
              </R>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 48 }}>
            <Link to="/get-quote" className="btn-grad">
              Get a free quote for your project →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export function ServiceDetail() {
  const { id } = useParams();
  const svc = services.find(s => s.id === id);
  if (!svc) return <Navigate to="/services" replace />;

  return (
    <div>
      <section
        className="page-hero"
        style={{ background: 'linear-gradient(135deg,var(--gray-50),var(--white))' }}
      >
        <div className="ph-orb ph-orb-1" />
        <div className="container page-hero-inner">
          <Link to="/services" className="back-link">← All services</Link>
          <div className="svc-hero-icon" style={{ background: svc.color }}>{svc.icon}</div>
          <h1 className="ph-title">{svc.title}</h1>
          <p className="ph-sub">{svc.tagline}</p>
          <div className="svc-hero-meta">
            <span className="shm-item">⏱ Timeline: <strong>{svc.timeline}</strong></span>
            <span className="shm-item">💰 Starting at: <strong>{svc.startingAt}</strong></span>
          </div>
          <div className="hero-actions" style={{ justifyContent: 'flex-start', marginTop: 28 }}>
            <Link to={`/get-quote?service=${encodeURIComponent(svc.title)}`} className="btn-grad">
              Get a quote →
            </Link>
            <Link to="/contact" className="btn-out">Talk to us</Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container svc-detail-grid">
          <div className="svc-detail-main">
            <h2 className="svc-section-head">Overview</h2>
            {svc.fullDesc.split('\n\n').map((p, i) => (
              <p key={i} className="svc-detail-para">{p}</p>
            ))}
            <h2 className="svc-section-head" style={{ marginTop: 40 }}>Our Process</h2>
            <div className="svc-process">
              {svc.process.map((step, i) => (
                <div key={step} className="svc-proc-step">
                  <div className="sps-num">{i + 1}</div>
                  <div className="sps-text">{step}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="svc-detail-side">
            <div className="svc-features-card">
              <h3>What's included</h3>
              <ul className="svc-features">
                {svc.features.map(f => (
                  <li key={f}><span className="sf-check">✓</span>{f}</li>
                ))}
              </ul>
            </div>
            <div className="svc-cs-card">
              <div className="svc-cs-metric">{svc.caseStudy.metric}</div>
              <div className="svc-cs-label">{svc.caseStudy.label}</div>
              <div className="svc-cs-client">— {svc.caseStudy.client}</div>
            </div>
            <Link
              to={`/get-quote?service=${encodeURIComponent(svc.title)}`}
              className="btn-grad"
              style={{ display: 'block', textAlign: 'center', marginTop: 16 }}
            >
              Start your project →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
